import { render, staticRenderFns } from "./UsedCouponsItem.vue?vue&type=template&id=0c28949a&scoped=true"
import script from "./UsedCouponsItem.vue?vue&type=script&lang=js"
export * from "./UsedCouponsItem.vue?vue&type=script&lang=js"
import style0 from "./UsedCouponsItem.vue?vue&type=style&index=0&id=0c28949a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28949a",
  null
  
)

export default component.exports